/** A match that is in play, or has kicked off and is still waiting for a score. */
export function isOnNow(fixture, now = Date.now()) {
  const status = String(fixture?.status || "").toLowerCase();
  if (fixture?.postponed || status === "finished" || status === "postponed") return false;
  if (status === "live") return true;
  const kick = new Date(fixture?.match_date).getTime();
  if (!Number.isFinite(kick)) return false;
  return status === "scheduled" && kick <= now && now - kick < 3 * 60 * 60 * 1000;
}

/** Poll faster when a match is on, or about to kick off. */
export function isScoreHot(fixtures, now = Date.now()) {
  if (!Array.isArray(fixtures)) return false;
  return fixtures.some((fixture) => {
    if (isOnNow(fixture, now)) return true;
    const status = String(fixture?.status || "").toLowerCase();
    const kick = new Date(fixture?.match_date).getTime();
    return status === "scheduled" && Number.isFinite(kick) && kick > now && kick - now < 20 * 60 * 1000;
  });
}

export function latestSync(fixtures) {
  const times = (fixtures || [])
    .map((fixture) => new Date(fixture.last_sync_at).getTime())
    .filter((time) => Number.isFinite(time));
  if (!times.length) return null;
  return new Date(Math.max(...times));
}

export function formatUpdated(value, now = Date.now()) {
  const time = value instanceof Date ? value.getTime() : new Date(value).getTime();
  if (!Number.isFinite(time)) return null;
  const minutes = Math.round((now - time) / 60000);
  if (minutes < 1) return "Updated just now";
  if (minutes < 60) return `Updated ${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 36) return `Updated ${hours} hr ago`;
  return null;
}

export function tableLine(rows, username) {
  if (!Array.isArray(rows) || !rows.length || !username) return null;
  const index = rows.findIndex((row) => row.username === username);
  if (index < 0) return null;
  const pointsOf = (row) => Number(row.points ?? row.score ?? 0);
  const me = rows[index];
  const place = `#${me.rank ?? index + 1} of ${rows.length}`;
  const above = index > 0 ? rows[index - 1] : null;
  if (!above || pointsOf(above) - pointsOf(me) <= 0) return `You're ${place} · top of the table`;
  return `You're ${place} · ${pointsOf(above) - pointsOf(me)} pts behind ${above.username}`;
}
